import { ReactComponent as EyeIcon } from "../../../assets/icons/fi-eye.svg";
import { ReactComponent as EyeSlash } from "../../../assets/icons/eye-slash.svg";

const InputField = ({
  label,
  type,
  name,
  placeholder,
  IconComponent,
  value,
  onChange,
  toggleVisibility,
  showPassword,
  error,
  iconColor = "#9E9E9E",
  onFocus,
  onBlur,
}) => {
  return (
    <div className="flex flex-col space-y-2">
      {label && (
        <label
          htmlFor={name}
          className="text-[14px] font-sf-medium text-[#1C1A3C]"
        >
          {label}
        </label>
      )}

      <div className="relative">
        <input
          id={name}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          autoComplete={type === "password" ? "new-password" : "off"}
          className={`w-full px-4 pl-10 py-3 border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-lg focus:outline-none focus:ring-2 ${
            error ? "focus:ring-red-500" : "focus:ring-blue-500"
          }`}
          required
        />

        {/* Left Icon */}
        <span className="absolute left-3 top-3 mt-0.5 text-gray-400 pointer-events-none">
          <IconComponent color={error ? "red" : iconColor} />
        </span>

        {/* Toggle Password Visibility */}
        {toggleVisibility && (
          <span
            className="absolute right-3 top-3 mt-0.5 text-gray-400 cursor-pointer"
            onClick={toggleVisibility}
            aria-label="Toggle password visibility"
          >
            {showPassword ? (
              <EyeIcon color={error ? "red" : iconColor} />
            ) : (
              <EyeSlash color={error ? "red" : iconColor} />
            )}
          </span>
        )}
      </div>

      {/* Error message */}
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  );
};

export default InputField;
